import React, { useContext } from 'react';
import { Navigate, Outlet } from 'react-router-dom';

import Loading from '../components/Loading';
import { AuthContext } from '../providers/Auth';
import Log from '../services/Log';

const GuardedRoute = () => {
  const { data } = useContext(AuthContext);

  Log.message(`Guard Route - ${data.loading}, ${JSON.stringify(data.user)}`);

  if (data.loading) {
    return <Loading />;
  }

  return data.user !== null ? <Outlet /> : <Navigate to="/" />;
};

export default GuardedRoute;
